module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/octopus-star4.de885cee.png";